import React from 'react';
import { Box, Card, Container, styled } from '@mui/material';
import { CenteredLayout } from '../CenteredLayout';
import * as path from 'path';
import { useNavigate } from 'react-router-dom';
import { LogoWrapperB2B } from '../../shared/logos/LogoWrapperB2B';

export const AuthenticationsLayout: React.FC<{ children: React.ReactNode }> = (
    props
) => {
    let navigate = useNavigate();
    const routeChange = () => {
        navigate('/login');
    };

    return (
        <>
            <CenteredLayout>
                <Container>
                    <Box
                        sx={{
                            maxWidth: '300px',
                            margin: 'auto',
                            paddingBottom: '30px',
                            cursor: 'pointer',
                        }}
                        // onClick={routeChange}
                    >
                        <LogoWrapperB2B />
                        {/*<img*/}
                        {/*    src="/assets/MESTER_SZERELVENYOLT_logo_RGB.svg"*/}
                        {/*    alt={'mester-szerelvenybolt'}*/}
                        {/*/>*/}
                    </Box>
                </Container>
                <Card
                    sx={{
                        padding: '20px',
                    }}
                >
                    {props.children}
                </Card>
            </CenteredLayout>
        </>
    );
};
